var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEndOfTracksZero(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.25 11.5C28.25 10.8096 27.6904 10.25 27 10.25H5C4.30964 10.25 3.75 10.8096 3.75 11.5V15.5C3.75 16.1904 4.30964 16.75 5 16.75H27C27.6904 16.75 28.25 16.1904 28.25 15.5V11.5ZM29.75 15.5C29.75 17.0188 28.5188 18.25 27 18.25H5C3.48122 18.25 2.25 17.0188 2.25 15.5V11.5C2.25 9.98122 3.48122 8.75 5 8.75H27C28.5188 8.75 29.75 9.98122 29.75 11.5V15.5Z",
    fill: "#B0BEC5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6915 16.8057L14.6551 9.94051H21.6437L17.6801 16.8057H10.6915Z",
    fill: "#B0BEC5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02515 7.5C7.02515 6.67157 7.69672 6 8.52515 6C9.35357 6 10.0251 6.67157 10.0251 7.5V9H7.02515V7.5Z",
    fill: "#B0BEC5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02515 16.9907H10.0251V22.9907H7.02515V16.9907Z",
    fill: "#B0BEC5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0251 23C28.1297 23 29.0251 23.8954 29.0251 25V26L3.02514 26L3.02514 25C3.02514 23.8954 3.92058 23 5.02515 23L27.0251 23Z",
    fill: "#B0BEC5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0251 7.5C22.0251 6.67157 22.6967 6 23.5251 6C24.3536 6 25.0251 6.67157 25.0251 7.5V9H22.0251V7.5Z",
    fill: "#B0BEC5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0251 16.9907H25.0251V22.9907H22.0251V16.9907Z",
    fill: "#B0BEC5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndOfTracksZero);
export default __webpack_public_path__ + "static/media/END_OF_TRACKS_ZERO.24be57ed66e9dde26e377f355b26e1eb.svg";
export { ForwardRef as ReactComponent };